import React from 'react';
import { connect } from 'react-redux';
import { selectSpinnerGlobal } from '../redux/selectors';

const SpinnerGlobal = (props) => {
  let cl = '';
  if (props.spinnerGlobal === true) {
    cl = ' show';
  }
  return (
    <div className={"spinner-global " + cl}><div className="bg-stripes"></div></div>
  );
};

// export default SpinnerGlobal;
function mapStateToProps(state) {
  return {
    spinnerGlobal: selectSpinnerGlobal(state)
  };
}
export default connect(mapStateToProps)(SpinnerGlobal);